import type {
  PushNotificationContent,
  SendPushToAllRequest,
} from '@/domain/push_notifications/entities/push_notification.entity'
import type { SendPushNotificationDto, SendPushToAllDto } from '../dto/push_notification.dto'

export function mapPushContentToDto(content: PushNotificationContent): SendPushNotificationDto {
  return {
    title: content.title,
    message: content.message,
  }
}

export function mapSendToAllToDto(request: SendPushToAllRequest): SendPushToAllDto {
  return {
    userType: request.userType,
    title: request.title,
    message: request.message,
  }
}

export function mapSendToAllFromStrings(
  userType: string,
  title: string,
  message: string
): SendPushToAllRequest {
  return {
    userType: userType as SendPushToAllRequest['userType'],
    title,
    message,
  }
}
